import Position from '@/types/user/position'
import { BaseService } from './../../base'
export class PositionService extends BaseService<Position>() {
    static get entity (): string {
        return 'position'
    }
    static get responseName (): string {
        return 'position'
    }
}